import { v4 as uuidv4 } from 'uuid'
/**
 * Returns a UUID without hyphens to satisfy https://ketch-com.atlassian.net/browse/KD-4230
 * @return uuid sans hyphens, and adds a leading 'b' to satisfy https://ketch-com.atlassian.net/browse/KD-4230
 * */
export const getUuidWithoutHyphensAndStartingWithALetter = () => {
  return `b${uuidv4().replaceAll('-', '')}`
}
